import { paymentService } from '../../helpers/services/payment.service'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  details: {},
  status: { list: true, detail: true, save: true },
}

export const PAYMENT_MODULE = 'payment'

export const GET_ALL_PAYMENTS = 'getAllPayments'
export const GET_PAYMENT = 'getPayment'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const DETAIL_SUCCESS = 'detailSuccess'

function mapRow(item) {
  return {
    docNo: item.doc_no,
    debtorCode: item.debtor_code,
    debtorName: item.debtor_name,
    docDate: filtersHelper.getDateFormat(item.doc_date),
    amount: item.amount,
    paymentMethod: item.payment_method,
    chequeNo: item.cheque_no,
    description: item.description,
  }
}

export const actions = {
  [GET_ALL_PAYMENTS]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    paymentService.getAllPayments(filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_PAYMENT]({ commit }, { docNo }) {
    commit(REQUESTING, 'detail')
    return paymentService.getPayment(docNo).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [DETAIL_SUCCESS](state, data) {
    state.details = data.data ? mapRow(data.data) : {}
  },
  [FAILURE](state) { state.status = { list: true, detail: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
